import { Card, CardContent, Container } from '@mui/material'
import { t } from 'i18next'
import React from 'react'

function LegalNotice() {
    return (
        <div className='app-bg' >
            <Container maxWidth='lg' sx={{ minHeight: '100vh', py: 10 }}>
                <Card>
                    <CardContent>
                        <span dangerouslySetInnerHTML={{ __html: t('content') }}></span>
                    </CardContent>
                </Card>
            </Container>
        </div>
    )
}

export default LegalNotice